import { FeatureEnum } from './featureAccess.enum';

interface User {
    __featureAccess__?: Array<{ feature: string }>;
}

/**
 * Checks if a user has access to a specific feature based on their feature flags
 * @param user The user object containing feature access information
 * @param feature The feature to check access for
 * @returns boolean indicating whether the user has access to the feature
 */
export const userHasAccess = (user: User, feature: FeatureEnum): boolean => {
    const userFeatures = user?.__featureAccess__ || [];
    const hasAccess = userFeatures?.some(f => f.feature === feature);
    return hasAccess;
}; 
